<template>
    <!-- <div class="row justify-between full-width no-wrap text-filter-item"> -->
      <!-- <div class="col"> -->
        <div class="row justify-left no-wrap">
          <q-toggle
            v-model="element.Positive"
            checked-icon="add"
            color="navy"
            label=""
            size="xs"
            unchecked-icon="remove"
          />
          <div :class="['q-my-none', 'q-pt-xs', 'cursor-pointer', { 'text-grey-8': !element.Value }]">{{ getElementName }}
            <q-popup-edit v-model="element.Value" auto-save fit v-slot="scope">
              <q-input v-model="element.Value" outlined dense autofocus 
              no-error-icon debounce="500" @keyup.enter="scope.set" />
            </q-popup-edit>
          </div>
        </div>
      <!-- </div> -->
      <!-- <div class="col"> -->
        <q-btn
          class="q-px-none q-mx-none q-mt-xs unset-items-center"
          flat
          dense
          :aria-label="$t('delete_filter')"
          icon="close"
          size="sm"
          tabindex="-1"
          color="accent"
          @click="deleteItem"
        >
          <q-tooltip :delay="300" anchor="top middle" self="center middle">
            {{ $t('remove') }}
          </q-tooltip>
        </q-btn>
      <!-- </div> -->
    <!-- </div> -->
  </template>
  
  <script lang="ts">
  import { Component, Emit, Prop, Vue, Watch } from 'vue-facing-decorator';
  import { SelectionTextFilterSend } from '@/models/interfaces/entity-settings/filters/filters';
  
  @Component({
    name: 'TextItemElement'
  })
  export default class TextItemElement extends Vue {
      @Prop({ default: {} as SelectionTextFilterSend })
      element!: SelectionTextFilterSend
  
      @Prop({ default: false })
      isRoot!: boolean

      @Emit("itemDeleted") emitDeleteItem(arg: number) { return arg; }
  
      @Prop({ default: undefined })
      parentId!: number | undefined
      @Prop({ default: undefined })
      parentIdx!: string | undefined
      @Prop({ default: '' })
      parentName!: string
      @Prop({ default: -1 })
      inputIndex!: number
      
      // temporary data
      tempName: string = ''
  
      created() {
          //
      }
  
      get getElementName(): string {
        return this.element.Value || this.$t('untitled')
      }
  
      deleteItem() {
        this.emitDeleteItem(this.inputIndex)
      }
  }
  </script>
  
  <style lang="scss">
  .minw-text-element {
    font-size: small !important;
  }
  
  .text-filter-item {
    &--child {
      margin-left: 26px !important;
    }
  }
  </style>